import React, { useEffect, useRef } from "react";
import HomeLayout from "../components/home/home-layout";
import LottieLoading from "../components/lottie/lottie-loading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useNavigationStore } from "../store/navigationStore";
// import { getRoute } from "../api/zeelo";
import { useLanguageStore } from "../store/languageStore";
import { NavigationData, NavigationDataResponse } from "../types/navigation";
import { getRoute } from "@/api/dwm_api";
import { EVENT, trackEvent } from "@/utils/analytics";

const ShareNavigation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const appLanguage = useLanguageStore((state) => state.appLanguage);
  const voiceLanguage = useLanguageStore(state => state.voiceLanguage)
  const setNavData = useNavigationStore(state => state.setNavData);
  const setVenueNotSupported = useNavigationStore(state => state.setVenueNotSupported);
  const token = searchParams.get("t");
  const referrer = searchParams.get("r");
  const startedRef = useRef(false);
  let navigate = useNavigate();
  const setNavFrom = useNavigationStore((state) => state.setNavFrom);
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    handleFindNavPath();
    setVoiceOn(false);

    if (token)
      trackEvent(EVENT.VISIT_SHARE_NAV_PAGE, { sharedLink: token, referrer: referrer ?? "unknown" });

  }, [token]);

  const handleFindNavPath = async () => {
    if (!token) return;

    try {
      const res = await getRoute(token);
      console.log("getRoute res", res);
      if (res.data) {
        const navData: NavigationDataResponse = {
          nav: [res.data],
          message: res.navAnswer,
          // conversation_id: "",
          // from: "none"
        };
        await setNavData(navData, voiceLanguage);
        setNavFrom(res.data.startingPoi.name ?? "");
        navigate("/navigation", { state: { referrer: referrer } });
      } else {
        setVenueNotSupported(true);
        navigate("/");
      }
    } catch (e) {
      console.error("error when retrieving shared path", e);
      navigate("/");
    }
  };

  return (
    <div className="flex flex-1 p-4 items-center justify-center">
      <LottieLoading />
    </div>
  );
};

const ShareNavPage: React.FC = () => {
  return <HomeLayout children={<ShareNavigation />}></HomeLayout>;
};

export default ShareNavPage;
